import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  // --- Rotas públicas ------------------------------------------------------
  {
    path: 'select-platform',
    loadComponent: () =>
      import('./features/select-platform/select-platform').then((m) => m.SelectPlatformComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login').then((m) => m.LoginComponent),
  },
  {
    path: 'esqueci-senha',
    loadComponent: () =>
      import('./features/auth/forgot-password/forgot-password').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'redefinir-senha',
    loadComponent: () =>
      import('./features/auth/reset-password/reset-password').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'definir-senha',
    // Convite: GET /api/loggic/auth/invite/{token} · POST /api/loggic/auth/accept-invite (?token= via input binding)
    loadComponent: () =>
      import('./features/auth/set-password/set-password').then((m) => m.SetPasswordComponent),
  },

  // --- App autenticado (shell + rotas por papel) ---------------------------
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./features/shell/shell').then((m) => m.ShellComponent),
    children: [
      {
        path: 'dashboard',
        canActivate: [roleGuard(['Owner', 'Member'])],
        // GET /api/admin/dashboard
        loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.DashboardComponent),
      },
      {
        path: 'cupons',
        // Back: somente Owner (loggic:owner). GET/POST/PATCH /api/admin/subscription-coupons (+ /{id}/usages)
        canActivate: [roleGuard(['Owner'])],
        loadComponent: () => import('./features/coupons/coupons').then((m) => m.CouponsComponent),
      },
      {
        path: 'parceiros',
        canActivate: [roleGuard(['Owner'])],
        // GET/POST/PUT /api/admin/partners (+ /{id}/payouts)
        loadComponent: () => import('./features/partners/partners').then((m) => m.PartnersComponent),
      },
      {
        path: 'lojas',
        canActivate: [roleGuard(['Owner', 'Member'])],
        // GET /api/admin/stores?search=&page=&pageSize=
        loadComponent: () => import('./features/stores/stores').then((m) => m.StoresComponent),
      },
      {
        path: 'assinaturas',
        canActivate: [roleGuard(['Owner', 'Member'])],
        // GET /api/admin/subscriptions · GET /api/admin/invoices · POST /api/admin/invoices/{id}/nf · GET …/nf-url
        loadComponent: () => import('./features/subscriptions/subscriptions').then((m) => m.SubscriptionsComponent),
      },
      {
        path: 'taxa-global',
        canActivate: [roleGuard(['Owner'])],
        // GET/PATCH /api/admin/fee-schedule
        loadComponent: () => import('./features/fee-schedule/fee-schedule').then((m) => m.FeeScheduleComponent),
      },
      {
        path: 'equipe',
        canActivate: [roleGuard(['Owner'])],
        // GET/POST /api/admin/team · PATCH …/{id}/active · POST …/{id}/resend-invite
        loadComponent: () => import('./features/team/team').then((m) => m.TeamComponent),
      },
      {
        path: 'base-conhecimento',
        canActivate: [roleGuard(['Owner', 'Member'])],
        // CMS: GET/POST/PUT/DELETE /api/admin/help/{categories,articles,faq}
        loadComponent: () =>
          import('./features/knowledge-base/knowledge-base').then((m) => m.KnowledgeBaseComponent),
      },
      {
        path: 'chamados',
        canActivate: [roleGuard(['Owner', 'Member'])],
        // GET /api/admin/support-requests (+ /{id}, /{id}/messages, /{id}/status)
        loadComponent: () => import('./features/support/support').then((m) => m.SupportComponent),
      },
      {
        path: 'auditoria',
        canActivate: [roleGuard(['Owner'])],
        // GET /api/admin/audit?search=&page=&pageSize=
        loadComponent: () => import('./features/audit/audit').then((m) => m.AuditComponent),
      },
      {
        path: 'parceiro',
        canActivate: [roleGuard(['Partner'])],
        // GET /api/partner/dashboard · /referrals · /commissions · /payouts (escopado ao token)
        loadComponent: () => import('./features/partner-portal/partner-portal').then((m) => m.PartnerPortalComponent),
      },
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
    ],
  },

  { path: '**', redirectTo: '' },
];
